import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type SearchAnimal = {
  animalId: number;
  orgId?: number;
  name?: string;
};

export type SearchContact = {
  contactId: number;
  orgId?: number;
  userId?: number;
  contactType?: number;
  contactFullName?: string;
  contactFirstName?: string;
  contactLastName?: string;
  emailAddress?: string;
};

export type SearchService = {
  serviceId: number;
  orgId?: number;
  name?: string;
  description?: string;
};

export type SearchResults = {
  animalList: SearchAnimal[];
  contactList: SearchContact[];
  serviceList: SearchService[];
};

function mapAnimals(list: unknown[] | null | undefined): SearchAnimal[] {
  return (list ?? []).map((item) => {
    const row = item as Record<string, unknown>;
    return {
      animalId: Number(row.animalId ?? row.AnimalId ?? 0),
      orgId: row.orgId != null ? Number(row.orgId) : undefined,
      name: row.name != null ? String(row.name) : undefined,
    };
  });
}

function mapContacts(list: unknown[] | null | undefined): SearchContact[] {
  return (list ?? []).map((item) => {
    const row = item as Record<string, unknown>;
    return {
      contactId: Number(row.contactId ?? row.ContactId ?? 0),
      orgId: row.orgId != null ? Number(row.orgId) : undefined,
      userId:
        row.userId != null
          ? Number(row.userId)
          : row.UserId != null
          ? Number(row.UserId)
          : undefined,
      contactType:
        row.contactType != null
          ? Number(row.contactType)
          : row.ContactType != null
          ? Number(row.ContactType)
          : undefined,
      contactFullName:
        row.contactFullName != null ? String(row.contactFullName) : undefined,
      contactFirstName:
        row.contactFirstName != null ? String(row.contactFirstName) : undefined,
      contactLastName:
        row.contactLastName != null ? String(row.contactLastName) : undefined,
      emailAddress:
        row.emailAddress != null ? String(row.emailAddress) : undefined,
    };
  });
}

function mapServices(list: unknown[] | null | undefined): SearchService[] {
  return (list ?? []).map((item) => {
    const row = item as Record<string, unknown>;
    return {
      serviceId: Number(row.serviceId ?? row.ServiceId ?? 0),
      orgId: row.orgId != null ? Number(row.orgId) : undefined,
      name: row.name != null ? String(row.name) : undefined,
      description:
        row.description != null ? String(row.description) : undefined,
    };
  });
}

export async function searchSystem(
  accessToken: string,
  orgId: number,
  textString: string
): Promise<VgApiResult<SearchResults>> {
  const { data, error } = await vgApiRequest<Record<string, unknown>>(
    accessToken,
    "SearchSystem",
    {
      orgId,
      textString,
    }
  );

  if (error) return { data: null, error };

  return {
    data: {
      animalList: mapAnimals((data?.animalList ?? data?.AnimalList) as unknown[]),
      contactList: mapContacts((data?.contactList ?? data?.ContactList) as unknown[]),
      serviceList: mapServices((data?.serviceList ?? data?.ServiceList) as unknown[]),
    },
    error: null,
  };
}
